import { saveAs } from 'file-saver';
import EventBus from '@/app/eventBus';
import { API, ENDPOINTS } from '@/app/services/api-url';
import INVESTMENT_STRATEGY from '@/app/modules/pdf/components/inv-strat/inv-strat.vue';
import INVESTMENT_STRATEGY_REVIEW from '@/app/modules/pdf/components/inv-strat-review/inv-strat-review.vue';
import RENT_RELIEF_INELIGIBLE from '@/app/modules/pdf/components/rent-relief/rent-relief-ineligible.vue';
import RENT_RELIEF_ELIGIBLE from '@/app/modules/pdf/components/rent-relief/rent-relief-eligible.vue';
import PENSION_ESTABLISHMENT from '@/app/modules/pdf/containers/pension-establishment/pension-establishment.vue';
import PENSION_PAYMENT_INSTRUCTION from '@/app/modules/pdf/components/pension-payment-instruction/pension-payment-instruction.vue';

export default {
  name: 'pdf-container',
  components: {
    INVESTMENT_STRATEGY,
    RENT_RELIEF_INELIGIBLE,
    RENT_RELIEF_ELIGIBLE,
    INVESTMENT_STRATEGY_REVIEW,
    PENSION_ESTABLISHMENT,
    PENSION_PAYMENT_INSTRUCTION,
  },
  data: () => ({
    showPreviewModal: false,
  }),
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    item() {
      return this.$store.getters['toolkit/getItem'];
    },
    isItemLoaded() {
      return (this.$store.getters['fund/hasFund']
       && typeof this.$store.getters['toolkit/getItem'].uuid === 'string');
    },
    itemType() {
      const type = this.$store.getters['toolkit/getItemType'];
      if (type === 'COVID' || type === 'RENT_RELIEF') {
        const outcome = this.$store.getters['toolkit/getItemData'].determination.impactedByCovid;
        return `RENT_RELIEF_${(outcome === 'yes') ? 'ELIGIBLE' : 'INELIGIBLE'}`;
      }
      return type;
    },
    isPensionEstablishment() {
      return this.itemType === 'PENSION_ESTABLISHMENT';
    },
    isInvStrat() {
      return this.itemType === 'INVESTMENT_STRATEGY';
    },
    isInvStratReview() {
      return this.itemType === 'INVESTMENT_STRATEGY_REVIEW';
    },
    isPensionPartOne() {
      if (this.isPensionEstablishment) {
        return this.$store.getters['toolkit/getItemData'].setup.part === 'PART_1';
      }
      return null;
    },
  },
  methods: {
    showPreview() {
      this.$mixpanel.track('Toolkit Item', {
        context: 'Item Step',
        step: 'Review',
        action: 'Preview',
        status: 'In Progress',
        type: this.$store.getters['toolkit/getItemType'],
        uuid: this.item.uuid,
      });
      this.showPreviewModal = !this.showPreviewModal;
    },
    getContent() {
      let content = document.getElementById('pdfContent').cloneNode(true);
      if (this.isPensionEstablishment) {
        content = document.getElementById('pensionEstablishmentPdfContent').cloneNode(true);
      }
      return this.formatContent(content);
    },
    getDocContent() {
      return this.formatContent(document.getElementById('wordTemplate').cloneNode(true));
    },
    getSchedule() {
      return this.formatContent(document.getElementById('schedule').cloneNode(true));
    },
    getPDS() {
      return this.formatContent(document.getElementById('pds').cloneNode(true));
    },
    formatContent(content) {
      const tailwindLink = document.createElement('link');
      tailwindLink.href = 'https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css';
      tailwindLink.rel = 'stylesheet';
      content.prepend(tailwindLink);
      return content;
    },
    getFooterTemplate() {
      const type = this.$store.getters['toolkit/getItemType'];
      let footerTemplate = '';
      if (type === 'COVID' || type === 'RENT_RELIEF' || type === 'PENSION_PAYMENT_INSTRUCTION') {
        footerTemplate = `
        <div>
        </div>
      `;
      } else {
        footerTemplate = `
        <div style='font-size: 10px; margin: 0 auto;'>
          <span class='pageNumber'></span>
          <span> / </span>
          <span class='totalPages'></span>
        </div>
      `;
      }
      return footerTemplate;
    },
    getPdfOptions() {
      return {
        format: 'A4',
        displayHeaderFooter: true,
        headerTemplate: '<div></div>',
        footerTemplate: this.getFooterTemplate(),
        margin: {
          top: '100',
          left: '80',
          right: '80',
          bottom: '100',
        },
      };
    },
    getDocOptions() {
      return {
        title: this.fund.details.name,
        subject: this.fund.details.name,
        creator: this.$store.getters['account/getAccountUser'].fullName,
        keywords: ['Super Toolkit'],
        lastModifiedBy: 'Super Toolkit',
        font: 'Arial CYR',
      };
    },
    handleDownloadSchedule() {
      this.$mixpanel.track('Toolkit Item', {
        context: 'Item Step',
        step: 'Review',
        doc_type: 'schedule',
        action: 'Download',
        status: 'In Progress',
        type: this.$store.getters['toolkit/getItemType'],
        uuid: this.item.uuid,
      });
      const schedule = this.getSchedule();
      const pdsPdfOptions = this.getPdfOptions();
      API.post(ENDPOINTS.POST_RENDER_PDF, {
        content: schedule.innerHTML,
        pdfOptions: JSON.stringify(pdsPdfOptions),
      }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.itemType.toLowerCase()}_${this.fund.details.name.split(' ').join('-')}_Schedule.pdf`);
        document.body.appendChild(link);
        link.click();
      }).catch((err) => {
        console.log(err);
      });

      EventBus.$emit('addNotification', {
        title: 'Download Requested!',
        icon: 'tick',
        message: 'Your PDF(s) will download automatically when ready!',
      });
    },
    handleDownloadDOC() {
      if (this.showPreviewModal) {
        this.showPreviewModal = false;
      }
      this.$mixpanel.track('Toolkit Item', {
        context: 'Item Step',
        step: 'Review',
        action: 'Download Word Doc',
        status: 'In Progress',
        type: this.$store.getters['toolkit/getItemType'],
        uuid: this.item.uuid,
      });
      const content = this.getDocContent();
      const docOptions = this.getDocOptions();
      API.post(ENDPOINTS.POST_RENDER_DOCX, {
        content: content.innerHTML.replace(new RegExp('<!---->', 'g'), ''),
        options: JSON.stringify(docOptions),
      }).then((res) => {
        const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
          const byteCharacters = atob(b64Data);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, { type: contentType });

          return blob;
        };

        const blob = b64toBlob(res.data, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');

        saveAs(blob, `${this.itemType.toLowerCase()}_${this.fund.details.name.split(' ').join('-')}.docx`);
      }).catch((err) => {
        console.log(err);
      });

      EventBus.$emit('addNotification', {
        title: 'Download Requested!',
        icon: 'tick',
        message: 'Your Word Doc will download automatically when ready!',
      });
    },
    handleDownload() {
      if (this.showPreviewModal) {
        this.showPreviewModal = false;
      }

      this.$mixpanel.track('Toolkit Item', {
        context: 'Item Step',
        step: 'Review',
        action: 'Download',
        status: 'In Progress',
        type: this.$store.getters['toolkit/getItemType'],
        uuid: this.item.uuid,
      });
      /*
       * TODO: Workaround to prevent style changes due to external css file.
       * Possible rework to groundControl
       */
      const content = this.getContent();
      const pdfOptions = this.getPdfOptions();
      if (this.itemType === 'PENSION_ESTABLISHMENT') {
        pdfOptions.footerTemplate = '<div></div>';
      }
      API.post(ENDPOINTS.POST_RENDER_PDF, {
        content: content.innerHTML,
        pdfOptions: JSON.stringify(pdfOptions),
      }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        const itemType = this.itemType.toLowerCase() === 'benefit_payment_instruction' ? 'benefit_payment_instruction' : this.itemType.toLowerCase();
        link.setAttribute('download', `${itemType}_${this.fund.details.name.split(' ').join('-')}.pdf`);
        document.body.appendChild(link);
        link.click();
      }).catch((err) => {
        console.log(err);
      });

      if (this.isPensionEstablishment) {
        // Download PDS also
        const pds = this.getPDS();
        const pdsPdfOptions = this.getPdfOptions();
        pdsPdfOptions.margin.top = '60';
        pdsPdfOptions.margin.bottom = '60';
        pdsPdfOptions.margin.left = '60';
        pdsPdfOptions.margin.right = '60';
        API.post(ENDPOINTS.POST_RENDER_PDF, {
          content: pds.innerHTML,
          pdfOptions: JSON.stringify(pdsPdfOptions),
        }).then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${this.itemType.toLowerCase()}_${this.fund.details.name.split(' ').join('-')}_PDS.pdf`);
          document.body.appendChild(link);
          link.click();
        }).catch((err) => {
          console.log(err);
        });
      }

      EventBus.$emit('addNotification', {
        title: 'Download Requested!',
        icon: 'tick',
        message: 'Your PDF(s) will download automatically when ready!',
      });
    },
  },
};
